"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FileManagerAttachmentPlugin;

var _immutable = require("immutable");

var _partial = _interopRequireDefault(require("transmute/partial"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _hubspotEmbeddingApps = _interopRequireDefault(require("hubspot.embedding.apps.file_manager"));

var _ToolbarActionPlugin = _interopRequireDefault(require("./ToolbarActionPlugin"));

var DEFAULT_OPTS = {
  messageKey: 'customerDataCommunicator.attachmentOptions.sharedFiles',
  onAttachmentSelected: _emptyFunction.default,
  onPluginOpenModal: _emptyFunction.default,
  onPluginCloseModal: _emptyFunction.default
};

function handleToolbarActionClick(onAttachmentSelected, onPluginOpenModal, onPluginCloseModal) {
  onPluginOpenModal();

  var complete = function complete(src, file) {
    onAttachmentSelected((0, _immutable.fromJS)(file));
  };

  _hubspotEmbeddingApps.default.openFilePicker({
    complete: complete,
    hideStockImages: true
  }).then(onPluginCloseModal);
}

function FileManagerAttachmentPlugin() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  opts = Object.assign({}, DEFAULT_OPTS, opts);
  opts.onClick = (0, _partial.default)(handleToolbarActionClick, opts.onAttachmentSelected, opts.onPluginOpenModal, opts.onPluginCloseModal);
  return (0, _ToolbarActionPlugin.default)(opts);
}

module.exports = exports.default;